<template>
  <div class="d-flex justify-center align-center" style="min-height: 100vh">
    <v-dialog v-model="changePasswordDialog" persistent max-width="450">
      <v-card class="card pa-4">
        <h2 class="text-center">{{ $t('change_password_title') }}</h2>
        <p>{{ $t('change_password_content') }}</p>

        <v-form ref="changeForm">
          <v-text-field
            hide-details="auto"
            v-model="newPassword"
            placeholder="********"
            :rules="[
              (v) => !!v || 'Campo obrigatório',
              (v) =>
                v != user.password ||
                'A senha não pode ser igual a senha anterior',
              (v) => /\d/.test(v) || 'Mínimo de um número',
              minLength(this.newPassword),
              specialCharacters(this.newPassword),
              uppercaseLetter(this.newPassword),
            ]"
            required
            class="ma-1"
            :label="$t('Defina sua nova senha')"
            :append-icon="
              changeShow ? 'mdi-eye-outline' : 'mdi-eye-off-outline'
            "
            :type="changeShow ? 'text' : 'password'"
            @click:append="changeShow = !changeShow"
          ></v-text-field>

          <v-text-field
            hide-details="auto"
            placeholder="********"
            :rules="[(v) => v == newPassword || 'Senhas não coincidem!']"
            class="ma-1"
            required
            :label="$t('Confirmação da senha')"
            :append-icon="
              changeShow2 ? 'mdi-eye-outline' : 'mdi-eye-off-outline'
            "
            :type="changeShow2 ? 'text' : 'password'"
            @click:append="changeShow2 = !changeShow2"
          ></v-text-field>
        </v-form>

        <div class="d-flex justify-end align-center mt-4">
          <v-btn
            color="primary"
            class="ma-0"
            depressed
            @click="changePassword"
            :loading="changeLoading"
            >{{ $t('Salvar') }}</v-btn
          >
        </div>
      </v-card>
    </v-dialog>

    <div class="conteudo">
      <div class="card-div" v-if="step === 0">
        <TCard
          title="Login"
          :titlePage="$t('Bem-vindo')"
          :descriptionPage="
            $t('Entre com usuário e senha para ter acesso ao sistema')
          "
        >
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row class="flex-column" align="start">
              <v-col>
                <v-text-field
                  hide-details="auto"
                  v-model="user.username"
                  placeholder="willie.jennings@example.com"
                  :rules="[(v) => !!v || 'E-mail requerido']"
                  @keydown.enter="login"
                  required
                  label="Usuário"
                  :append-icon="'mdi-account-outline'"
                />
              </v-col>
            </v-row>
            <v-row class="flex-column senha" align="start">
              <v-col class="mb-4">
                <v-text-field
                  hide-details="auto"
                  v-model="user.password"
                  placeholder="********"
                  :rules="passwordRules"
                  @keydown.enter="login"
                  required
                  :label="$t('Senha')"
                  :append-icon="
                    show ? 'mdi-eye-outline' : 'mdi-eye-off-outline'
                  "
                  :type="show ? 'text' : 'password'"
                  @click:append="show = !show"
                />
              </v-col>
              <v-col class="d-flex justify-center">
                <div id="recaptcha-container"></div>
              </v-col>
            </v-row>
            <v-btn
              depressed
              :loading="loading"
              :disabled="!valid"
              block
              class="primary-button mt-4"
              @click="login"
            >
              Acessar o Fix System
            </v-btn>
          </v-form>

          <div class="d-flex align-center my-4">
            <v-divider></v-divider>
            <span class="mx-3" style="color: #999; white-space: nowrap"
              >ou</span
            >
            <v-divider></v-divider>
          </div>

          <div class="google-sso-wrapper">
            <v-btn
              outlined
              block
              class="sso-button"
              :loading="googleSsoLoading"
              tabindex="-1"
            >
              <img
                src="@/assets/icons/google-logo.svg"
                alt="Google"
                class="mr-2"
                style="width: 20px; height: 20px"
              />
              Entrar com Google
            </v-btn>
            <div ref="googleButton" class="google-button-overlay"></div>
          </div>

          <v-btn
            outlined
            block
            class="sso-button mt-2"
            :loading="ssoLoading"
            @click="loginWithMicrosoft"
          >
            <img
              src="@/assets/icons/microsoft-logo.svg"
              alt="Microsoft"
              class="mr-2"
              style="width: 20px; height: 20px"
            />
            Entrar com Microsoft
          </v-btn>

          <div class="btn-forgot-password my-12">
            <span @click="$router.push({ name: 'ForgotPassword' })">
              {{ $t('Esqueceu sua senha?') }}
            </span>
          </div>
        </TCard>
      </div>

      <!-- Ambos os sistemas -->
      <v-row
        v-if="step === 1 && eqpOnlineToken && institutions.length > 0"
        justify="center"
        align="center"
        class="cards-sistemas-row mt-8 w-100"
      >
        <v-col
          cols="12"
          md="5"
          class="d-flex align-stretch"
          v-if="institutions.length > 0"
        >
          <v-card
            outlined
            elevation="0"
            class="mt-2 pa-4 text-center sistema-card flex-grow-1 d-flex flex-column"
          >
            <v-img
              src="@/assets/icons/fix_icon_logo_2.svg"
              contain
              max-width="140"
              class="mx-auto mb-7"
            />
            <h3 class="text-center">Gestão da Qualidade e Manutenção</h3>
            <span>Selecione uma instituição para acesso</span>
            <v-autocomplete
              :label="$t('Instituição')"
              append-icon="mdi-chevron-down"
              hide-details="auto"
              v-model="institution"
              :items="institutions"
              item-text="name"
              return-object
            ></v-autocomplete>
            <v-spacer class="my-2" />
            <v-btn
              depressed
              :loading="loading"
              :disabled="!valid"
              block
              class="primary-button mt-12"
              @click="setInst"
            >
              Acessar Gestão da Qualidade e Manutenção
            </v-btn>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          md="5"
          class="d-flex align-stretch"
          v-if="eqpOnlineToken"
        >
          <v-card
            outlined
            elevation="0"
            class="pa-4 mt-2 text-center sistema-card flex-grow-1 d-flex flex-column"
          >
            <v-img
              src="@/assets/icons/fix_icon_logo_2.svg"
              contain
              max-width="140"
              class="mx-auto mb-7"
            />
            <h3 class="text-center">Planejamento e Aquisição</h3>
            <v-spacer class="my-2" />
            <span>
              Detectamos que você possui uma conta no Planejamento e Aquisição,
              clique no botão abaixo para acessar.
            </span>
            <v-spacer class="my-2" />
            <v-btn
              depressed
              :loading="loading"
              :disabled="!valid"
              block
              class="primary-button mt-15"
              :href="
                'https://equipacareonline.azurewebsites.net/auth/validar-login?token=' +
                eqpOnlineToken
              "
            >
              Acessar Planejamento e Aquisição
            </v-btn>
          </v-card>
        </v-col>
      </v-row>

      <!-- Apenas Equipacare Online -->
      <v-row
        v-else-if="
          step === 1 &&
          eqpOnlineToken &&
          (!institutions || institutions.length === 0)
        "
        justify="center"
        align="center"
        class="cards-sistemas-row mt-8 w-100"
      >
        <v-col cols="12" md="5" class="d-flex align-stretch justify-center">
          <v-card
            outlined
            elevation="0"
            class="pa-4 mt-2 text-center sistema-card flex-grow-1 d-flex flex-column"
          >
            <v-img
              src="@/assets/icons/fix_icon_logo_2.svg"
              contain
              max-width="140"
              class="mx-auto mb-7"
            />
            <h3 class="text-center">Planejamento e Aquisição</h3>
            <v-spacer class="my-2" />
            <span>
              Detectamos que você possui uma conta no Planejamento e Aquisição,
              clique no botão abaixo para acessar.
            </span>
            <v-spacer class="my-2" />
            <v-btn
              depressed
              :loading="loading"
              :disabled="!valid"
              block
              class="primary-button mt-18"
              :href="
                'https://equipacareonline.azurewebsites.net/auth/validar-login?token=' +
                eqpOnlineToken
              "
            >
              Acessar Planejamento e Aquisição
            </v-btn>
          </v-card>
        </v-col>
      </v-row>

      <!-- Apenas Fix  -->
      <v-row
        v-else-if="step === 1 && !eqpOnlineToken && institutions.length > 0"
        justify="center"
        align="center"
        class="cards-sistemas-row mt-8 w-100"
      >
        <v-col cols="12" md="5" class="d-flex align-stretch justify-center">
          <v-card
            outlined
            elevation="0"
            class="mt-2 pa-4 text-center sistema-card flex-grow-1 d-flex flex-column"
          >
            <v-img
              src="@/assets/icons/fix_icon_logo_2.svg"
              contain
              max-width="140"
              class="mx-auto mb-7"
            />
            <h3 class="text-center">Gestão da Qualidade e Manutenção</h3>
            <span>Selecione uma instituição para acesso</span>
            <v-autocomplete
              :label="$t('Instituição')"
              append-icon="mdi-chevron-down"
              hide-details="auto"
              v-model="institution"
              :items="institutions"
              item-text="name"
              return-object
            ></v-autocomplete>
            <v-spacer class="my-2" />
            <v-btn
              depressed
              :loading="loading"
              :disabled="!valid"
              block
              class="primary-button mt-7"
              @click="setInst"
            >
              Acessar Gestão da Qualidade e Manutenção
            </v-btn>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import ApiService from '../../../services/ApiService'
import TCard from '../../../components/T/TCardAuth.vue'
import Component from '../../../components/toast.vue'
import CryptoJS from 'crypto-js'
import { msalInstance, loginRequest } from '../../../services/MsalService'
import { shouldRedirectToV2, redirectToV2 } from '../../../config/v2'
import { resolveQrCodeRedirect } from '../../../config/qrCodeRedirect'
import {
  renderGoogleButton,
  waitForGoogleScript,
} from '../../../services/GoogleAuthService'

export default {
  components: {
    TCard,
  },

  data() {
    return {
      changeLoading: false,
      changePasswordDialog: false,
      step: 0,
      show: false,
      changeShow: false,
      changeShow2: false,
      loading: false,
      valid: true,
      styleClass: { color: '#fff' },
      apiService: new ApiService(),
      user: {
        username: '',
        password: '',
      },
      passwordRules: [(v) => !!v || 'Senha requerida'],
      emailRules: [
        (v) => !!v || 'E-mail requerido',
        (v) => /.+@.+\..+/.test(v) || 'E-mail inválido',
      ],
      institution: {},
      institutions: [],
      isLogged: false,
      userLogged: {},
      token: '',
      validTo: '',
      openPatchNotes: false,
      newPassword: '',
      eqpOnlineToken: '',
      ssoLoading: false,
      googleSsoLoading: false,
    }
  },

  async mounted() {
    if (await this.handleWorkspaceReturn()) return

    try {
      const response = await msalInstance.handleRedirectPromise()
      if (response && response.idToken) {
        await this.processAzureSsoLogin(response.idToken)
        return
      }
    } catch (err) {
      console.error('SSO redirect error:', err)
    }

    try {
      grecaptcha.ready(function () {
        grecaptcha.render('recaptcha-container', {
          sitekey: '6Lc9yr8qAAAAAMoQnqQPINTl8QROzeiZTq7qtEg4',
        })
      })
    } catch {
      window.location.reload()
    }

    this.initGoogleButton()
  },

  methods: {
    encryptPassword(password) {
      const base64Key = 't5PSvsnXASeiseBli5x7rqwEs40IDxXS6+pNR854W3o='
      const secretKey = CryptoJS.enc.Base64.parse(base64Key)
      const ciphertext = CryptoJS.AES.encrypt(password, secretKey, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }).toString()
      return ciphertext
    },

    specialCharacters(v) {
      if (v.length) {
        const specialCharacters = /[!@#$%^&*()_+[\]{};:'"<>,.?/~\\-]/

        if (specialCharacters.test(v) == false)
          return 'Mínimo de um caractere especial'

        return true
      }
      return true
    },

    uppercaseLetter(v) {
      if (v.length) {
        const uppercaseLetter = /[A-Z]/

        if (uppercaseLetter.test(v) == false)
          return 'Mínimo de uma letra maiúscula'

        return true
      }
      return true
    },

    minLength(v) {
      if (v.length) {
        if (v.length < 8) {
          return 'Mínimo de 8 caracteres'
        }
      }
      return true
    },

    async setInst() {
      localStorage.removeItem('institution')

      this.$i18n.locale = this.institution.locale
        ? this.institution.locale
        : 'pt'
      localStorage.removeItem('locale')
      localStorage.setItem('locale', this.$i18n.locale)

      this.$store.commit(
        'SET_INSTITUTION_USER',
        JSON.stringify(this.institution),
      )

      localStorage.removeItem('user')
      localStorage.setItem('user', JSON.stringify(this.userLogged))

      if (shouldRedirectToV2(this.institution, this.userLogged)) {
        redirectToV2()
        return
      }

      await this.apiService
        .get(`called/pendent-rating/${this.institution.id}`)
        .then((response) => {
          this.userLogged.pendingCalleds = response.content

          localStorage.removeItem('user')
          localStorage.setItem('user', JSON.stringify(this.userLogged))

          if (
            this.userLogged.pendingCalleds &&
            this.userLogged.pendingCalleds.length > 0
          ) {
            this.$toast(Component, {
              position: 'top-right',
              timeout: 10000,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: false,
              draggablePercent: 0.6,
              showCloseButtonOnHover: true,
              closeButton: 'button',
              icon: true,
              rtl: false,
            })
          }
        })

      if (this.institution.userType == 6) {
        this.$router.push('/calleds')
      } else {
        this.$router.push('/serviceOrders')
      }
    },

    async loginWithMicrosoft() {
      try {
        this.ssoLoading = true
        await msalInstance.loginRedirect(loginRequest)
      } catch (err) {
        console.error('SSO login error:', err)
        this.$toast.error('Erro ao iniciar login com Microsoft')
        this.ssoLoading = false
      }
    },

    async initGoogleButton() {
      try {
        await waitForGoogleScript()
        if (!this.$refs.googleButton) return
        const parentWidth =
          this.$refs.googleButton.parentElement?.offsetWidth || 400
        const width = Math.max(200, Math.min(400, parentWidth))
        renderGoogleButton(
          this.$refs.googleButton,
          (idToken) => {
            this.processSsoLogin(
              idToken,
              'auth/signin-google-sso',
              'googleSsoLoading',
            )
          },
          { width },
        )
      } catch (err) {
        console.error('Google SSO init error:', err)
      }
    },

    async processAzureSsoLogin(idToken) {
      await this.processSsoLogin(idToken, 'auth/signin-sso', 'ssoLoading')
    },

    async handleWorkspaceReturn() {
      const { samlCode, ssoError } = this.$route.query

      if (!samlCode && !ssoError) return false

      this.$router.replace({ query: {} }).catch(() => {})

      if (ssoError) {
        this.$toast.error(ssoError.toString())
        return true
      }

      await this.processSamlLogin(samlCode)
      return true
    },

    async processSamlLogin(code) {
      this.loading = true
      this.googleSsoLoading = true

      try {
        const result = await this.apiService.post('auth/saml/exchange', {
          code,
        })

        await this.applyLoginResult(result)
      } catch (err) {
        this.clearSessionStorage()
        this.loading = false
        this.googleSsoLoading = false
      }
    },

    async processSsoLogin(idToken, endpoint, loadingFlag) {
      this.loading = true
      this[loadingFlag] = true

      try {
        const result = await this.apiService.post(endpoint, {
          idToken,
        })

        await this.applyLoginResult(result)
      } catch (err) {
        this.clearSessionStorage()
        this.loading = false
        this[loadingFlag] = false
      }
    },

    async applyLoginResult(result) {
      this.eqpOnlineToken = ''
      if (result.content.eqpOnlineToken) {
        this.eqpOnlineToken = result.content.eqpOnlineToken
      }

      this.userLogged = result.content.user
      this.token = result.content.token
      this.validTo = result.content.validTo
      this.openPatchNotes = result.content.openPatchNotes

      localStorage.removeItem('user')
      localStorage.removeItem('token')
      localStorage.removeItem('validTo')

      this.$store.commit('SET_LOGGED_USER', JSON.stringify(result.content.user))
      this.$store.commit('SET_CURRENT_TOKEN', this.token)
      this.$store.commit('SET_EXPIRES_TOKEN', this.validTo)

      await this.getInstitutions()
      localStorage.setItem('institution', JSON.stringify(this.institutions[0]))

      const redirectedFromQrCode = await this.redirectFromQrCode()

      this.step = 1
      this.loading = false
      this.ssoLoading = false
      this.googleSsoLoading = false

      if (redirectedFromQrCode) return

      this.$i18n.locale =
        this.institution && this.institution.locale
          ? this.institution.locale
          : 'pt'
      localStorage.removeItem('locale')
      localStorage.setItem('locale', this.$i18n.locale)

      setTimeout(() => {
        this.$root.$emit('OpenNotes', result.content.openPatchNotes)
      }, 500)
    },

    clearSessionStorage() {
      localStorage.removeItem('token')
      localStorage.removeItem('expires')
      localStorage.removeItem('user')
      localStorage.removeItem('institution')
    },

    async login() {
      if (this.$refs.form.validate()) {
        let recaptchaResponse = null
        try {
          recaptchaResponse = grecaptcha.getResponse()
          if (!recaptchaResponse) {
            this.$toast.warning(
              'Por favor, complete o reCAPTCHA para prosseguir',
            )
            return
          }
        } catch {
          window.location.reload()
        }

        this.loading = true
        this.user.username = this.user.username.trim().toLowerCase()
        const password = this.encryptPassword(this.user.password)

        await this.apiService
          .post('auth/signin-captcha', {
            username: this.user.username,
            password,
            recaptcha: recaptchaResponse,
          })
          .then(async (result) => {
            this.eqpOnlineToken = ''
            if (result.content.eqpOnlineToken) {
              this.eqpOnlineToken = result.content.eqpOnlineToken
            }

            this.userLogged = result.content.user
            this.token = result.content.token
            this.validTo = result.content.validTo
            this.openPatchNotes = result.content.openPatchNotes

            if (result.content.haveToChangePassword) {
              this.loading = false
              this.changePasswordDialog = true
              return
            }

            localStorage.removeItem('user')
            localStorage.removeItem('token')
            localStorage.removeItem('validTo')
            const user = JSON.stringify(result.content.user)

            this.$store.commit('SET_LOGGED_USER', user)
            this.$store.commit('SET_CURRENT_TOKEN', this.token)
            this.$store.commit('SET_EXPIRES_TOKEN', this.validTo)

            await this.getInstitutions()
            localStorage.setItem(
              'institution',
              JSON.stringify(this.institutions[0]),
            )

            if (await this.redirectFromQrCode()) {
              this.step = 1
              this.loading = false
              return
            }

            const equipment = JSON.parse(localStorage.getItem('equipmentId'))
            const calledId = this.$route.query.calledId

            if (equipment) {
              this.$router.push('/newCalled')
            } else if (calledId) {
              this.$router.push('/calleds?calledId=' + calledId)
            }

            if (this.institution.userType == 6) {
              this.$router.push('/calleds')
            }

            this.step = 1

            this.loading = false

            this.$i18n.locale =
              this.institution && this.institution.locale
                ? this.institution.locale
                : 'pt'
            localStorage.removeItem('locale')
            localStorage.setItem('locale', this.$i18n.locale)

            setTimeout(() => {
              this.$root.$emit('OpenNotes', result.content.openPatchNotes)
            }, 500)
          })
          .catch((err) => {
            localStorage.removeItem('token')
            localStorage.removeItem('expires')
            localStorage.removeItem('user')
            localStorage.removeItem('institution')
            this.loading = false
          })
      }
    },

    async changePassword() {
      if (!this.$refs.changeForm.validate()) {
        return
      }

      this.changeLoading = true

      this.apiService
        .post('user/password/update', {
          id: this.userLogged.id,
          currentPassword: this.user.password,
          newPassword: this.newPassword,
        })
        .then(async (response) => {
          this.changePasswordDialog = false
          this.changeLoading = false
          localStorage.removeItem('user')
          localStorage.removeItem('token')
          localStorage.removeItem('validTo')
          const user = JSON.stringify(this.userLogged)

          this.$store.commit('SET_LOGGED_USER', user)
          this.$store.commit('SET_CURRENT_TOKEN', this.token)
          this.$store.commit('SET_EXPIRES_TOKEN', this.validTo)

          await this.getInstitutions()

          if (await this.redirectFromQrCode()) {
            this.step = 1
            this.loading = false
            return
          }

          const equipment = JSON.parse(localStorage.getItem('equipmentId'))
          const calledId = this.$route.query.calledId

          if (equipment) {
            this.$router.push('/newCalled')
          } else if (calledId) {
            this.$router.push('/calleds?calledId=' + calledId)
          }

          if (this.institution.userType == 6) {
            this.$router.push('/calleds')
          }

          this.step = 1

          this.loading = false

          this.$i18n.locale =
            this.institution && this.institution.locale
              ? this.institution.locale
              : 'pt'
          localStorage.removeItem('locale')
          localStorage.setItem('locale', this.$i18n.locale)

          setTimeout(() => {
            this.$root.$emit('OpenNotes', this.openPatchNotes)
          }, 500)
        })
        .catch(() => {
          this.changeLoading = false
        })
    },

    async redirectFromQrCode() {
      const redirect = await resolveQrCodeRedirect(this.institutions)

      if (!redirect) return false

      if (redirect.lookupFailed) {
        this.$toast.warning(
          'Não foi possível carregar o equipamento escaneado. Tente novamente.',
        )
        return false
      }

      if (redirect.deniedInstitution) {
        this.$toast.warning(
          'O equipamento escaneado pertence a outra instituição.',
        )
        return false
      }

      localStorage.setItem('institution', JSON.stringify(redirect.institution))

      this.$i18n.locale = redirect.institution.locale
        ? redirect.institution.locale
        : 'pt'
      localStorage.removeItem('locale')
      localStorage.setItem('locale', this.$i18n.locale)

      this.$router.push(redirect.path)

      return true
    },

    async getInstitutions() {
      this.institutions = []
      this.loading = true
      await this.apiService
        .get('institution/list-with-user-type')
        .then((response) => {
          this.institutions = response.content
        })
        .catch((err) => {})

      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/sass/variables.scss';
.login-container {
  padding: 1.5rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}

.conteudo {
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  padding: 0.5rem;
  gap: 1rem;
  position: relative;

  .card-div {
    max-width: 700px;
    width: 100%;
    z-index: 2;
    position: relative;
    .login-btn {
      background: $blue-1 !important;
      width: 100%;
      margin: 1rem 0;
    }
    .btn-forgot-password {
      text-align: center;
      span {
        text-decoration-line: underline;
        cursor: pointer;
        color: $blue-2;
        font-weight: 600;
      }
    }
  }
}

// Adicione fora do bloco acima:
.cards-sistemas-row {
  z-index: 3;
  position: relative;
}

.sistema-card {
  min-height: 350px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.sso-button {
  text-transform: none !important;
  font-weight: 500;
  letter-spacing: normal;
  border-color: #ddd;
}

.google-sso-wrapper {
  position: relative;
}

.google-button-overlay {
  position: absolute;
  inset: 0;
  opacity: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
}

.google-button-overlay ::v-deep > div,
.google-button-overlay ::v-deep iframe {
  width: 100% !important;
  height: 100% !important;
}

@media screen and (max-width: $mobile-1) {
  .info {
    display: none !important;
  }
}
</style>
